import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Scale, X, ArrowRight } from "lucide-react";
import { useCompare } from "@/context/CompareContext";

const CompareBar = () => {
  const { items, removeCompare, clearCompare, count } = useCompare();
  const location = useLocation();

  // Hide on the compare page itself and admin
  if (count === 0 || location.pathname === "/comparar" || location.pathname.startsWith("/admin")) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        data-testid="compare-bar"
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-3xl"
      >
        <div className="flex items-center gap-3 rounded-2xl border border-emerald-500/40 bg-slate-950/85 glass px-4 py-3 shadow-[0_8px_40px_rgba(0,0,0,0.4)]">
          <Scale className="h-5 w-5 text-emerald-400 shrink-0" />
          <div className="flex-1 flex items-center gap-2 overflow-x-auto">
            {items.map((p) => (
              <div key={p.id} className="relative shrink-0 group">
                <img src={p.image} alt={p.name} className="h-11 w-11 rounded-lg object-cover border border-white/10" />
                <button
                  data-testid={`compare-bar-remove-${p.id}`}
                  onClick={() => removeCompare(p.id)}
                  className="absolute -top-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-900 border border-white/20 text-white hover:bg-red-500"
                >
                  <X className="h-3 w-3" />
                </button>
              </div>
            ))}
          </div>
          <button onClick={clearCompare} className="hidden sm:block text-xs text-slate-400 hover:text-white transition-colors">Limpiar</button>
          <Link
            to="/comparar"
            data-testid="compare-bar-go"
            className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 px-4 py-2.5 text-sm font-bold text-slate-950 whitespace-nowrap"
          >
            Comparar ({count}) <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CompareBar;
